import { IAppState } from "./interface";

export default <IAppState> {
	appKey: 1,
	contentKey: 1
}